import React from 'react';
import { Heading } from '../../../_lib/components/Heading/Heading';

type GalleryHeadlineProps = {
  id: string;
  children: string;
  ref?: React.RefObject<HTMLHeadingElement | null>;
};

export function GalleryHeadline({ id, children, ref }: GalleryHeadlineProps) {
  return (
    <Heading id={`gallery-headline-${id}`} hierarchy={4} className="image-gallery__headline" ref={ref}>
      {children}
    </Heading>
  );
}
